<template>
  <div class="search">
    <nc-search
      v-if="onlineSearch"
      @addProduct="addProduct($event)"
    />
    <offline-search
      v-else
      @addProduct="addProduct($event)"
    />

  </div>
</template>
<style lang="scss">
.search {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: $catalog__bg;
  display: flex;
  justify-content: stretch;
  align-items: stretch;
  &__container {
    display: flex;
    align-items: stretch;
    flex-direction: column;
    width: 100%;
  }
}
</style>
<script>
import { EventBus } from './../event-bus'
import ncSearch from './nc-search'
import offlineSearch from './offline-search'

export default {
	name: 'searchProduct',
	components: {
		ncSearch,
		offlineSearch
	},
	mounted () {
		let $this = this
		EventBus.$on('isOnline', (e) => {
			$this.online = e
		})
	},
	computed: {
		onlineSearch () {
			let useOfflineSearch = this.$store.getters.offlineSearch
			if (useOfflineSearch || !this.online) {
				return false
			}
			return true
		}
	},
	methods: {
		addProduct (data) {
			this.$emit('addProduct', data)
		}
	},
	data () {
		return {
			online: window.navigator.onLine
		}
	}
}
</script>
